// extracted by mini-css-extract-plugin
export default {"btn":"style_btn__nl+ue","select":"style_select__2Ef5T"};